import '../../css/supervisorcontrolls/supervisormenu.css';
import React, { useRef, useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { SelectBox } from 'devextreme-react/select-box';
import useMonitorAPIService from '../../services/monitorapiservice';
import DualListBox from 'react-dual-listbox';
import { selectionTypes, channels } from '../utils/consts';
import DataSource from 'devextreme/data/data_source';

function WidgetSettings(props) {


    const { t } = useTranslation();
    const { getSupervisedGroups, getSupervisedCorporateGroups } = useMonitorAPIService();

    const wrapperRef = useRef(null);
    const [groups, setGroups] = useState([]);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [groupId, setGroupId] = useState(props.groupId || -1);
    const [groupName, setGroupName] = useState(props.groupName || t("all2"));
    const [campaign, setCampaign] = useState(props.campaign || t("all"));
    const [channel, setChannel] = useState(props.channel || "");
    const [channelName, setChannelName] = useState(props.channelName || "");
    const [selectedCampaigns, setSelectedCampaigns] = useState([]);

    const groupedDataSource = useMemo(() => {
        return new DataSource({
            store: groups,
            group: 'category',
        });
    }, [groups]);

    useEffect(() => {

        const handleClickOutside = (e) => {
            if (props.showSettings && wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                // props.toggleSettings();
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        //UNMOUNT
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [props]);

    useEffect(() => {

        if (props.showSettings) {

            getSupervisedGroups(props.token, (res) => {
                if (res.data != null && res.data.length > 0) {
                    let groups = [];
                    res.data.sort(function (a, b) {

                        const nameA = a.groupName.toLowerCase();
                        const nameB = b.groupName.toLowerCase();

                        if (nameA < nameB) {
                            return -1;
                        } else if (nameA > nameB) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });

                    res.data.forEach(element => {
                        element.category = t("groups");
                    });

                    if (props.selectionType === selectionTypes.GROUP || props.selectionType === selectionTypes.CHANNEL) {
                        groups = [{ groupId: -1, groupName: t("all2") }].concat(res.data);
                    } else if (props.selectionType === selectionTypes.CAMPAIGN) {
                        groups = [{ groupId: -1, campaign: t("all") }].concat(res.data);
                    }
                    else {
                        groups = res.data;
                    }


                    if (props.selectionType !== selectionTypes.GROUPMULTIPLE && props.selectionType !== selectionTypes.CAMPAIGNMULTIPLE) {

                        getSupervisedCorporateGroups(props.token, (resgc) => {
                            if (resgc.data != null && resgc.data.length > 0) {
                                resgc.data.forEach(element => {
                                    element.groupId = element.id;
                                    element.groupName = element.name;
                                    element.category = t("corporategroups");
                                });
                            }
                            groups = groups.concat(resgc.data);
                            setGroups(groups);
                            setGroupId(props.groupId);
                            setSelectedGroups(props.groups);
                            setSelectedCampaigns(props.selectedCampaigns);
                        });

                    } else {
                        
                        setGroups(groups);
                        setGroupId(props.groupId);
                        setSelectedGroups(props.groups);
                        setSelectedCampaigns(props.selectedCampaigns);

                    }


                }
            });
        }
        //UNMOUNT
        return () => {

        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.showSettings]);

    const handleChange = (value) => {

        let group = groups.find(x => x.groupId === value);
        if (group) {
            setGroupId(group.groupId);
            setGroupName(group.groupName);
            setCampaign(group.campaign);
        }
    }

    const handleSend = (e) => {
        e.preventDefault();

        if (props.selectionType === selectionTypes.GROUP)
            props.setGroup(groupId, groupName);

        if (props.selectionType === selectionTypes.GROUPMULTIPLE)
            props.setGroups((selectedGroups || []));

        if (props.selectionType === selectionTypes.CAMPAIGN)
            props.setCampaign(groupId, campaign);

        if (props.selectionType === selectionTypes.CHANNEL)
            props.setGroupAndChannel(groupId, groupName, channel, channelName);

        if (props.selectionType === selectionTypes.MESSAGESQUEUE)
            props.setGroupsAndChannel((selectedGroups || []), channel, channelName);

        if (props.selectionType === selectionTypes.CAMPAIGNMULTIPLE)
            props.setCampaignsFilter((selectedCampaigns || []));
    }

    const handleChannelChange = (value) => {
        let channel = channels.find(x => x.id === value);
        if (channel) {
            setChannel(value);
            setChannelName(value ? channel.name : "");

        }
    };

    return (

        <div ref={wrapperRef} className={"menu-user menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color py-4 fs-6 w-400px  " + (props.showSettings ? "show" : "")}

        >

            {
                (props.selectionType === selectionTypes.CHANNEL || props.selectionType === selectionTypes.MESSAGESQUEUE) &&
                <div className="menu-item px-5">
                    <div className="mb-2">
                        <label className="form-label fw-semibold">{t("channel")}</label>
                        <div>
                            <SelectBox
                                dataSource={channels.map(x => { return { id: x.id, name: t(x.name) } })}
                                value={channel}
                                onValueChange={handleChannelChange}
                                valueExpr="id"
                                displayExpr="name"
                                searchEnabled={true}
                                dropDownButtonRender={() => { return (<FontAwesomeIcon icon={duotone("down")} />) }}
                            />
                        </div>
                    </div>
                </div>
            }
            {
                (props.selectionType === selectionTypes.GROUP || props.selectionType === selectionTypes.CHANNEL) &&
                <div className="menu-item px-5">
                    <div className="mb-2">
                        <label className="form-label fw-semibold">{t("group")}</label>
                        <div>
                            <SelectBox
                                dataSource={groupedDataSource}
                                value={groupId}
                                onValueChange={handleChange}
                                grouped={true}
                                valueExpr="groupId"
                                displayExpr="groupName"
                                searchEnabled={true}
                                dropDownButtonRender={() => { return (<FontAwesomeIcon icon={duotone("down")} />) }}
                            />
                        </div>
                    </div>
                </div>
            }
            {
                (props.selectionType === selectionTypes.GROUPMULTIPLE || props.selectionType === selectionTypes.MESSAGESQUEUE) &&
                <div className="menu-item px-5">
                    <div className="mb-2">
                        <label className="form-label fw-semibold">{t("groups")}</label>
                        <div>
                            <DualListBox
                                canFilter
                                options={groups.map(x => { return { value: x.groupId, label: x.groupName } })}
                                selected={selectedGroups}
                                onChange={(value) => setSelectedGroups(value)}
                                showHeaderLabels={true}
                                icons={{
                                    moveLeft: <FontAwesomeIcon icon={duotone("left")} />,
                                    moveAllLeft: [
                                        <FontAwesomeIcon key={0} icon={duotone("left")} />,
                                        <FontAwesomeIcon key={1} icon={duotone("left")} />,
                                    ],
                                    moveRight: <FontAwesomeIcon icon={duotone("right")} />,
                                    moveAllRight: [
                                        <FontAwesomeIcon key={0} icon={duotone("right")} />,
                                        <FontAwesomeIcon key={1} icon={duotone("right")} />,
                                    ]
                                }}

                            />
                        </div>
                    </div>
                </div>
            }

            {
                props.selectionType === selectionTypes.CAMPAIGN &&
                <div className="menu-item px-5">
                    <div className="mb-2">
                        <label className="form-label fw-semibold">{t("campaign")}</label>
                        <div>
                            <SelectBox
                                dataSource={groups.filter(x => x.campaign)}
                                value={groupId}
                                onValueChange={handleChange}
                                valueExpr="groupId"
                                displayExpr="campaign"
                                searchEnabled={true}
                                dropDownButtonRender={() => { return (<FontAwesomeIcon icon={duotone("down")} />) }}
                            />
                        </div>
                    </div>
                </div>
            }
            {
                (props.selectionType === selectionTypes.CAMPAIGNMULTIPLE) &&
                <div className="menu-item px-5">
                    <div className="mb-2">
                        <label className="form-label fw-semibold">{t("campaigns")}</label>
                        <div>
                            <DualListBox
                                canFilter
                                options={groups.filter(x => x.campaign !== null).map(x => { return { value: x.campaignId, label: x.campaign } })}
                                selected={selectedCampaigns}
                                onChange={(value) => setSelectedCampaigns(value)}
                                showHeaderLabels={true}
                                icons={{
                                    moveLeft: <FontAwesomeIcon icon={duotone("left")} />,
                                    moveAllLeft: [
                                        <FontAwesomeIcon key={0} icon={duotone("left")} />,
                                        <FontAwesomeIcon key={1} icon={duotone("left")} />,
                                    ],
                                    moveRight: <FontAwesomeIcon icon={duotone("right")} />,
                                    moveAllRight: [
                                        <FontAwesomeIcon key={0} icon={duotone("right")} />,
                                        <FontAwesomeIcon key={1} icon={duotone("right")} />,
                                    ]
                                }}

                            />
                        </div>
                    </div>
                </div>
            }
            <div className="d-flex justify-content-end">
                <button type="reset" className="btn btn-sm btn-light btn-active-light-primary me-2" onClick={e => { e.preventDefault(); props.toggleSettings(); }}>{t("close")}</button>
                <button type="submit" className="btn btn-sm btn-primary" onClick={handleSend}>{t("send")}</button>
            </div>
        </div>

    );
}

const mapStateToProps = (state) => {
    return {
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, {})(WidgetSettings);
